module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_photowedding-50ebe8b84492cab0c1f1cb9ab656fca6.webp";